import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { GalleryIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/host-management/gallery/$host-gallery')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle title="Gallery Management" icon={GalleryIcon} />,
      title: 'Gallery Management',
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
